<div class="wrapper">
  <div class="sidebar" *ngIf="showLayout()">
    <app-sidebar></app-sidebar>
  </div>
  <app-header *ngIf="showLayout()"></app-header>
  <main>
    <app-loading ngSkipHydration></app-loading>
    <router-outlet></router-outlet>
  </main>
</div>
